const minutes = (value) => {
  if (!value || !value.includes(":")) return null;
  const [hours, mins] = value.split(":").map(Number);
  return (hours * 60) + mins;
};

export const eventsOverlap = (first, second) => {
  if (!first.date || first.date !== second.date) return false;
  const values = [minutes(first.start_time), minutes(first.end_time), minutes(second.start_time), minutes(second.end_time)];
  if (values.some((value) => value === null)) return false;
  return values[0] < values[3] && values[2] < values[1];
};

export const getSchedulingConflicts = (events = []) => {
  const conflicts = [];
  for (let left = 0; left < events.length; left += 1) {
    for (let right = left + 1; right < events.length; right += 1) {
      const first = events[left];
      const second = events[right];
      if (!eventsOverlap(first, second)) continue;
      const sharedTeam = first.team_id && first.team_id === second.team_id;
      const sharedLocation = first.location && first.location !== "google_meet" && first.location === second.location;
      if (!sharedTeam && !sharedLocation) continue;
      conflicts.push({ id: `${first.event_id}:${second.event_id}`, first, second, reasons: [sharedTeam ? "Team" : null, sharedLocation ? "Location" : null].filter(Boolean) });
    }
  }
  return conflicts;
};

export const needsSchedulingDetails = (event) => !event.date || !event.start_time || !event.end_time || !event.location;
